import { useMutation } from '@hooks/reactQuery';

import { declineAssetByUnit } from '@api/assetsRent';

import { IApprovalActionAssetByUnitDTO } from '@interfaces/rent/dto/assetRentDTO';

import { APPROVAL_UNIT_INFO } from '@constants/queryKeys';

interface IUseMutateDeclineAssetByUnitProps {
	assetId: string;
	isAO: boolean;
	onSuccessCallbacks: Array<() => void>;
}

type TUseMutateDeclineAssetByUnitReturn = (data: IApprovalActionAssetByUnitDTO) => void;

export const useMutateDeclineAssetByUnit = ({
	assetId,
	isAO,
	onSuccessCallbacks,
}: IUseMutateDeclineAssetByUnitProps) => {
	const { mutate: declineAssetByApprovalUnit } = useMutation({
		mutationKey: [APPROVAL_UNIT_INFO, assetId, isAO],
		mutationFn: ({
			approvalUnitId,
			comment,
			itemId,
		}: IApprovalActionAssetByUnitDTO) => {
			return declineAssetByUnit({
				approvalUnitId,
				comment,
				itemId,
			});
		},
		onSuccess: () => {
			if (onSuccessCallbacks.length) onSuccessCallbacks.forEach((callback) => callback());
		},
	});

	return {
		declineAssetByApprovalUnit: declineAssetByApprovalUnit as unknown as TUseMutateDeclineAssetByUnitReturn,
	};
};
